import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BackendLocatorService } from './backend-locator.service';

@Injectable()
export class BackendLocatorInterceptor implements HttpInterceptor {
    constructor(private backendLocatorService: BackendLocatorService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const url = this.backendLocatorService.replaceUrl(req.url);

        return next.handle(req.clone({ url }));
    }
}
